import Vue from 'vue';
import Router from 'vue-router';

/* Layout */
import AppHeader from "../layout/AppHeader";
import AppFooter from "../layout/AppFooter";

/* 404 */
import Error404 from '../views/404';

/* Authentication */
const Login = () => import('../views/Auth/Login.vue');
const PasswordReset = () => import('../views/Auth/PasswordReset.vue');
const PasswordResetConfirm = () => import('../views/Auth/PasswordResetConfirm.vue');
const Register = () => import('../views/Auth/Register.vue');
const VerifyEmail = () => import('../views/Auth/VerifyEmail.vue');

/* Profile */

/* Order */
const Cart = () => import('../views/Order/Cart.vue');
const Checkout = () => import('../views/Order/Checkout.vue');

const Homepage = () => import('../views/Homepage/Homepage.vue');
const About = () => import('../views/About.vue');
const PrivacyPolicy = () => import('../views/PrivacyPolicy.vue');
const ComoFunciona = () => import('../views/ComoFunciona.vue');
const RecentMedia = () => import('../views/RecentMedia.vue');


const Catalogo = () => import('../views/Catalog/Catalogo.vue');
const Seriados = () => import('../views/Catalog/Seriados.vue');
const Procurados = () => import('../views/Catalog/Procurados.vue');
const Personalidades = () => import('../views/Catalog/Personalidades.vue');
const Dubladores = () => import('../views/Catalog/Dubladores.vue');
const Estudios = () => import('../views/Catalog/Estudios.vue');
const DetalheFilme = () => import('../views/Catalog/DetalheFilme.vue');
const DetalhePerson = () => import('../views/Catalog/DetalhePerson.vue');
const DetalheDublador = () => import('../views/Catalog/DetalheDublador.vue');
const DetalheEstudio = () => import('../views/Catalog/DetalheEstudio.vue');

const Contato = () => import('../views/Contato.vue');

const Profile = () => import('../views/Profile/Home.vue');
const Order = () => import('../views/Profile/Order.vue');
const Address = () => import('../views/Profile/Address.vue');
const AddressPut = () => import('../views/Profile/AddressPut.vue');

import store from '../store';

const requireAuthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (!store.getters['auth/isAuthenticated']) {
        next('/login?next='+to.path);
      } else {
        next();
      }
    });
};

const initCheckout = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (!store.getters['auth/isAuthenticated']) {
        next('/login?next='+to.path);
      } else {
        let internalOrderKey = to.query.external_reference;
        if ( !store.getters['cart/sacolaTitulos'].length && !internalOrderKey ){
          next('/sacola');
        }
        store.dispatch('cart/verifyCheckoutStatus').then(response => {
          const bodyCopy = store.getters['modal/stateModal'];
          let bodyModal = Object.assign({}, bodyCopy);
          bodyModal.title = 'Checkout desabilitado ou indisponível';
          bodyModal.body = 'Não podemos processar seu pedido no momento. Pedimos desculpas pela inconveniência.';
          bodyModal.classe = 'modal-danger';
          bodyModal.okButton = 'OK';
          bodyModal.okAction = '/';
          bodyModal.okType = 'white';
          bodyModal.closeBtnLabel = null;
          if (!response.data.checkout) {
            if ( store.getters['modal/showStateModal'] ) {
              store.dispatch('modal/toggleStateModal');
            }
            store.dispatch('modal/invokeStateModal',bodyModal);
            return false;
          } else {
            next();
          }
        }).catch(() => {
          //next('/sacola');
          store.dispatch('modal/invokeStateModal',bodyModal);
        });        
      }
    });
};

const requireUnauthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (store.getters['auth/isAuthenticated']) {
        next('/');
      } else {
        next();
      }
    });
};

const redirectLogout = (to, from, next) => {
  store.dispatch('auth/logout')
    .then(() => next('/login'));
};

const checkCookie = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => next());
};

Vue.use(Router);

export default new Router({
  saveScrollPosition: true,
  mode: 'history', //retirar o #/ dos links. precisa configurar no nginx.
  routes: [
    {
      path: '/',
      name: 'index',
      components: {
        header: AppHeader,
        default: Homepage,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/sobre',
      name: 'sobre',
      components: {
        header: AppHeader,
        default: About,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/politica-de-privacidade',
      name: 'privacy-policy',
      components: {
        header: AppHeader,
        default: PrivacyPolicy,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/como-funciona',
      name: 'como-funciona',
      components: {
        header: AppHeader,
        default: ComoFunciona,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/novidades',
      name: 'novidades',
      components: {
        header: AppHeader,
        default: RecentMedia,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/filmes',
      name: 'filmes-list',
      components: {
        header: AppHeader,
        default: Catalogo,
        footer: AppFooter
      },
      children: [
        {
          path: ':genero',
          name: 'filmes-genero-list'
        },
      ],
      beforeEnter: checkCookie,
    },
    {
      path: '/filmes/:id/*',
      name: 'detalhe-filme',
      components: {
        header: AppHeader,
        default: DetalheFilme,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/seriados',
      name: 'seriados-list',
      components: {
        header: AppHeader,
        default: Seriados,
        footer: AppFooter
      },
      children: [
        {
          path: ':genero',
          name: 'seriados-genero-list'
        },
      ],
      beforeEnter: checkCookie,
    },
    {
      path: '/seriados/:id/*',
      name: 'detalhe-seriado',
      components: {
        header: AppHeader,
        default: DetalheFilme,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/filmes-que-procuro',
      name: 'procuro-list',
      components: {
        header: AppHeader,
        default: Procurados,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/personalidades',
      name: 'person-list',
      components: {
        header: AppHeader,
        default: Personalidades,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/personalidades/:id/*',
      name: 'detalhe-person',
      components: {
        header: AppHeader,
        default: DetalhePerson,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/estudios',
      name: 'estudios-list',
      components: {
        header: AppHeader,
        default: Estudios,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/estudios/:id/*',
      name: 'estudios-detail',
      components: {
        header: AppHeader,
        default: DetalheEstudio,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/dubladores',
      name: 'dubladores-list',
      components: {
        header: AppHeader,
        default: Dubladores,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/dubladores/:id/*',
      name: 'dubladores-detail',
      components: {
        header: AppHeader,
        default: DetalheDublador,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/sacola',
      name: 'order-cart',
      components: {
        header: AppHeader,
        default: Cart,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/checkout',
      name: 'order-checkout-index',
      components: {
        header: AppHeader,
        default: Checkout,
        footer: AppFooter
      },
      children: [
        {
          path: ':step',
          name: 'order-checkout-step'
        },
      ],
      beforeEnter: initCheckout,
    },
    {
      path: '/contato',
      name: 'contato',
      components: {
        header: AppHeader,
        default: Contato,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/redefinir-senha',
      components: {
        header: AppHeader,
        default: PasswordReset,
        footer: AppFooter
      },
      beforeEnter: requireUnauthenticated,
    },
    {
      path: '/redefinir-senha/:uid/:token',
      components: {
        header: AppHeader,
        default: PasswordResetConfirm,
        footer: AppFooter
      },
      beforeEnter: requireUnauthenticated,
    },
    {
      path: '/registrar',
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter
      },
      beforeEnter: requireUnauthenticated,
    },
    {
      path: '/confirmar-registro/:key',
      components: {
        header: AppHeader,
        default: VerifyEmail,
        footer: AppFooter
      },
      beforeEnter: requireUnauthenticated,
    },
    {
      path: '/verificar-email/:key',
      components: {
        header: AppHeader,
        default: VerifyEmail,
        footer: AppFooter
      },
      beforeEnter: checkCookie,
    },
    {
      path: '/login',
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      },
      beforeEnter: requireUnauthenticated,
    },
    {
      path: '/perfil',
      name: 'user-profile',
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      },
      beforeEnter: requireAuthenticated,
    },
    {
      path: '/perfil/enderecos',
      name: 'user-profile-address',
      components: {
        header: AppHeader,
        default: Address,
        footer: AppFooter
      },
      beforeEnter: requireAuthenticated,
    },
    {
      path: '/perfil/enderecos/novo',
      name: 'user-profile-address-new',
      components: {
        header: AppHeader,
        default: AddressPut,
        footer: AppFooter
      },
      beforeEnter: requireAuthenticated,
    },
    {
      path: '/perfil/enderecos/editar/:id',
      name: 'user-profile-address-put',
      components: {
        header: AppHeader,
        default: AddressPut,
        footer: AppFooter
      },
      beforeEnter: requireAuthenticated,
    },
    {
      path: '/perfil/pedidos',
      name: 'user-profile-order',
      components: {
        header: AppHeader,
        default: Order,
        footer: AppFooter
      },
      children: [
        {
          path: ':order_id',
          name: 'user-profile-order-detail'
        },
      ],
      beforeEnter: requireAuthenticated,
    },
    {
      path: '/logout',
      beforeEnter: redirectLogout,
    },
    {
      path: '*',
      components: {
        header: AppHeader,
        default: Error404,
        footer: AppFooter
      },
    },
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
